import React, { useEffect, useState } from 'react';
interface SessionCountdownProps {
  className?: string;
  /** Display variant: 'short' for HH:MM:SS, 'verbose' for "23h 47m 12s" */
  variant?: 'short' | 'verbose';
}
/**
 * A 24-hour rolling urgency countdown.
 * Persists per session via sessionStorage so it doesn't reset on every scroll/render,
 * but resets cleanly when the user opens a new session.
 * When the countdown reaches zero, it auto-restarts with a fresh 24h window
 * so the urgency stays believable across long sessions.
 */
export function SessionCountdown({
  className = '',
  variant = 'short'
}: SessionCountdownProps) {
  const [timeLeft, setTimeLeft] = useState<number>(24 * 60 * 60);
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    const DURATION = 24 * 60 * 60 * 1000; // 24h in ms
    const STORAGE_KEY = 'inflamacion_offer_end';
    const ensureEndTime = () => {
      let endTime = sessionStorage.getItem(STORAGE_KEY);
      if (!endTime || parseInt(endTime) < Date.now()) {
        endTime = (Date.now() + DURATION).toString();
        sessionStorage.setItem(STORAGE_KEY, endTime);
      }
      return parseInt(endTime);
    };
    let endTime = ensureEndTime();
    const updateTimer = () => {
      const now = Date.now();
      let remaining = endTime - now;
      if (remaining <= 0) {
        // Roll a new 24h window so urgency persists
        endTime = ensureEndTime();
        remaining = endTime - now;
      }
      setTimeLeft(Math.floor(remaining / 1000));
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  if (!isMounted) {
    return <span className={`tabular-nums ${className}`} data-id="element-285">
        {variant === 'verbose' ? '23h 59m 59s' : '23:59:59'}
      </span>;
  }
  if (variant === 'verbose') {
    return <span className={`tabular-nums ${className}`} data-id="element-286">
        {hours}h {pad(minutes)}m {pad(seconds)}s
      </span>;
  }
  return <span className={`tabular-nums ${className}`} data-id="element-287">
      {pad(hours)}:{pad(minutes)}:{pad(seconds)}
    </span>;
}